"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

var _DialogForm = _interopRequireDefault(require("../DialogForm"));

/**
 * @component
 */
var WrapDialogForm = function WrapDialogForm(_ref) {
  var children = _ref.children,
      dialogProps = _ref.dialogProps,
      dialogTitle = _ref.dialogTitle,
      dirty = _ref.dirty,
      disabled = _ref.disabled,
      forceSave = _ref.forceSave,
      fullScreen = _ref.fullScreen,
      isSubmitting = _ref.isSubmitting,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      open = _ref.open,
      render = _ref.render,
      other = (0, _objectWithoutProperties2.default)(_ref, ["children", "dialogProps", "dialogTitle", "dirty", "disabled", "forceSave", "fullScreen", "isSubmitting", "onClose", "onSubmit", "open", "render"]);
  var renderer = children || render;
  (0, _tinyInvariant.default)(renderer, 'WrappDialogForm() at least one prop `render` or `children` have to be set.');
  var isDirty = forceSave || dirty;
  return /*#__PURE__*/_react.default.createElement(_DialogForm.default, (0, _extends2.default)({}, dialogProps, {
    dirty: isDirty,
    disabled: disabled,
    onSubmit: onSubmit,
    isSubmitting: isSubmitting,
    onClose: onClose,
    open: open,
    title: dialogTitle,
    fullScreen: fullScreen || false
  }), renderer((0, _extends2.default)({}, other, {
    dirty: dirty,
    disabled: disabled
  })));
};

process.env.NODE_ENV !== "production" ? WrapDialogForm.propTypes = {
  /**
     * Zobrazuje vyrenderovany obsah => {(children || render)({ ...other, dirty: isDirty })}
     */
  children: _propTypes.default.func,

  /**
     *  Titulka dialogu
     */
  dialogTitle: _propTypes.default.node,

  /**
     * `true` pokud byl formular jiz editovan.
     */
  dirty: _propTypes.default.bool,

  /**
     * `true` pokud je form needitovatelny.
     */
  disabled: _propTypes.default.bool,

  /**
     * Boolean pro moznost ukladani => save dialog data
     */
  forceSave: _propTypes.default.bool,

  /**
     * Boolean pro otevreni dialogu pres cele okno prohlizece
     */
  fullScreen: _propTypes.default.bool,

  /**
     * Boolean pro submiting dialogu
     */
  isSubmitting: _propTypes.default.bool,

  /**
     * Funkce na zavreni dialogu
     */
  onClose: _propTypes.default.func.isRequired,

  /**
     * Funkce pro potvrzeni dialogu
     */
  onSubmit: _propTypes.default.func.isRequired,

  /**
     * Funkce na otevreni dialogu
     */
  open: _propTypes.default.bool.isRequired,

  /**
     * Funkce pro renderovani
     */
  render: _propTypes.default.func
} : void 0;
WrapDialogForm.displayName = 'WrapDialogForm';
var _default = WrapDialogForm;
exports.default = _default;